(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Enhanced Search Functionality with Mobile Animation
  class HeaderSearchManager {
    constructor() {
      this.searchInput = document.getElementById('search-input');
      this.searchForm = document.getElementById('custom-search-form');
      this.resetButton = document.getElementById('search-reset');
      this.searchButton = document.getElementById('search-button');
      this.header = document.querySelector('.header');
      this.isMobile = window.innerWidth < 990;
      this.isSearchActive = false;
      
      if (this.searchInput && this.header) {
        this.init();
      }
    }

    init() {
      // Search input events
      this.searchInput.addEventListener('input', this.handleSearchInput.bind(this));
      this.searchInput.addEventListener('focus', this.handleSearchFocus.bind(this));
      this.searchInput.addEventListener('blur', this.handleSearchBlur.bind(this));
      
      // Search button click event
      if (this.searchButton) {
        this.searchButton.addEventListener('click', this.handleSearchButtonClick.bind(this));
      }
      
      // Reset button
      if (this.resetButton) {
        this.resetButton.addEventListener('click', this.handleReset.bind(this));
      }

      // Form submission
      this.searchForm.addEventListener('submit', this.handleFormSubmit.bind(this));

      // Click outside to deactivate
      document.addEventListener('click', this.handleClickOutside.bind(this));

      // Window resize handler
      window.addEventListener('resize', this.handleResize.bind(this));

      // Show/hide reset button based on input content
      this.toggleResetButton();
      
      // Set up observer to filter products from predictive search results
      this.setupResultsFilter();
    }

    handleResize() {
      const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth < 990;
      
      // If switching from mobile to desktop while search is active, deactivate
      if (wasMobile && !this.isMobile && this.isSearchActive) {
        this.deactivateSearch();
      }
    }

    handleSearchFocus() {
      this.searchInput.parentElement.classList.add('focused');
      this.activateSearch();
    }

    handleSearchBlur(event) {
      // Small delay to allow for potential click on other search elements
      setTimeout(() => {
        if (!this.isElementInSearchContainer(document.activeElement)) {
          this.searchInput.parentElement.classList.remove('focused');
          this.deactivateSearch();
        }
      }, 100);
    }

    handleSearchButtonClick(event) {
      // If on mobile and search not active, prevent form submission and activate search
      if (this.isMobile && !this.isSearchActive) {
        event.preventDefault();
        this.activateSearch();
        this.searchInput.focus();
        return;
      }
      // Otherwise, let form submit normally
    }

    handleFormSubmit() {
      // Deactivate search after form submission
      setTimeout(() => {
        this.deactivateSearch();
      }, 100);
    }

    handleClickOutside(event) {
      // Check if click is outside search container
      if (!this.isElementInSearchContainer(event.target)) {
        this.deactivateSearch();
      }
    }

    isElementInSearchContainer(element) {
      if (!element) return false;
      const searchContainer = document.querySelector('.custom-search-container');
      return searchContainer && (searchContainer.contains(element) || element === searchContainer);
    }

    activateSearch() {
      if (!this.isMobile || this.isSearchActive) return;
      
      this.isSearchActive = true;
      this.header.classList.add('search-active');
    }

    deactivateSearch() {
      if (!this.isSearchActive) return;
      
      this.isSearchActive = false;
      this.header.classList.remove('search-active');
    }

    setupResultsFilter() {
      // Create a MutationObserver to watch for changes in predictive search results
      const predictiveSearchContainer = document.getElementById('predictive-search-results');
      if (predictiveSearchContainer) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'childList') {
              this.filterProductResults();
            }
          });
        });

        observer.observe(predictiveSearchContainer, {
          childList: true,
          subtree: true
        });
      }
    }

    filterProductResults() {
      // Hide product results from predictive search
      const productGroups = document.querySelectorAll('.predictive-search__result-group[data-type="products"]');
      productGroups.forEach(group => {
        group.style.display = 'none';
      });

      // Also hide individual product results if they have different markup
      const productResults = document.querySelectorAll('.predictive-search__result[data-type="product"]');
      productResults.forEach(result => {
        result.style.display = 'none';
      });

      // Hide any results with product-related classes
      const productItems = document.querySelectorAll('.predictive-search__item--product');
      productItems.forEach(item => {
        item.style.display = 'none';
      });
    }

    handleSearchInput(event) {
      this.toggleResetButton();
      
      // Trigger predictive search if enabled
      if (window.predictiveSearch) {
        window.predictiveSearch.onInput(event);
      }
      
      // Filter products after a short delay to allow results to load
      setTimeout(() => {
        this.filterProductResults();
      }, 100);
    }

    handleReset() {
      this.searchInput.value = '';
      this.toggleResetButton();
      this.searchInput.focus();
      
      // Hide predictive search results
      const predictiveSearch = document.getElementById('predictive-search-results');
      if (predictiveSearch) {
        predictiveSearch.hidden = true;
      }
    }

    toggleResetButton() {
      if (this.resetButton) {
        if (this.searchInput.value.length > 0) {
          this.resetButton.classList.add('show');
        } else {
          this.resetButton.classList.remove('show');
        }
      }
    }
  }

  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    new HeaderSearchManager();
  });

  customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();
})();
